module.exports = __webpack_public_path__ + "img/枢源LOGO01.2841d941.svg";